import { ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { IReportEmbedConfiguration, models, } from 'powerbi-client';
import * as pbi from 'powerbi-client';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { ReportMapService } from 'src/app/reports/services/report-map.service';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { layerConstant } from 'src/app/common/constants/layer-constant';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { BiShowOnMapType } from '../bi-click-even-type.enum';

declare global {
  interface Window {
    DOWNLOAD_TOKEN?: string;
    SHOWONMAP_TOKEN?: string;
  }
}

const DOWNLOAD_TOKEN_VALUE = "dl-abc123"; // MUST match the Visual token For download request
const MESSAGE_SOURCE = 'powerbi-custom-visual';
const REQUEST_ACTION_DOWNLOAD = 'request-download';

const SHOWONMAP_TOKEN = "SOM-EST-123" // MUST match the Visual token For show on map request
const REQUEST_ACTION_SHOWONMAP = 'show-on-map';
const MESSAGE_SOURCE_SHOWONMAP = 'powerbi-custom-visual-showOnMap';

@Component({
  selector: 'app-power-bi-multi-page-view',
  templateUrl: './power-bi-multi-pages-view.component.html',
  styleUrls: ['./power-bi-multi-pages-view.component.scss']
})
export class PowerBiMultiPageViewComponent {
  @Input() params: any;

  //Scrollbar left to right
  @ViewChild('reportTab') reportTab: ElementRef | any;
  showLeftArrow = false;
  showRightArrow = false;
  private resizeObserver: ResizeObserver | any;
  currentLang: string = '';
  activeTabName: any;
  languageSub$: Subscription = new Subscription();
  report_data: any;

  embedDataURL:any =[];
  catchmentCount: number = 0;
  visualsGrFilter: pbi.Embed[] = [];
  powerbiService!: pbi.service.Service;
  powerBiReport: any;

  isFirstTime: boolean = true;

  currentReportView$: Subscription = new Subscription();
  currentReportView!: number;
  private destroy$ = new Subject<void>();
  pageLoader!: boolean;

  overViewMenu: any = [];
  currentScroll: any = 0;
  reportPage: any;

  constructor(private sharedService: SharedService, private cd: ChangeDetectorRef,
    private reportService: ReportService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private mapService: ReportMapService,
    private alertService: AlertService
  ) {
    window.DOWNLOAD_TOKEN = DOWNLOAD_TOKEN_VALUE;
    window.SHOWONMAP_TOKEN = SHOWONMAP_TOKEN;
    this.initializeLanguageListener();
  }

  private initializeLanguageListener(): void {
    this.sharedService.language$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        // this.updateSubMenu();
        if (lang && !this.isFirstTime) {
          this.getVisualFilter();
        }
      });
  }

  private handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      // this.visualsGrFilter.forEach((visual: any) => {
        this.reportPage?.refresh();
      // });
      this.getVisualFilter();
    }
  }

  ngOnInit() {
    this.setLang();
     this.isFirstTime = false;

    this.powerbiService = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );

    this.report_data = this.reportService.getCurrentReport().powerbi_data || null;

    this.activeTabName = this.report_data?.pb_container[0];

    this.bootstrapVisuals();

    this.loadVisualReport(this.report_data?.pb_container[0]);

    // this.updateSubMenu();

    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      if (this.currentReportView != view) {
        this.currentReportView = view;
        // this.updateLayoutSetting();
      }
    });

    let polygon;
    this.route.queryParams.subscribe((param: any) => {
      if (param?.polygon) {
        polygon = param?.polygon;
      }
    });

    if (polygon) {
      this.getCatchmentCount(polygon);
    }

    document.addEventListener(
      'visibilitychange',
      this.handleVisibilityChange.bind(this)
    );



    window.addEventListener('message', async (event: any) => {
      try {
        const msg = event.data;

        if (!msg) return;

        if (msg.action == REQUEST_ACTION_DOWNLOAD || typeof msg.csv == 'string') {

          if (msg.source !== MESSAGE_SOURCE) {
            return;
          }
          // token check
          if (!msg.token || msg.token !== window.DOWNLOAD_TOKEN) {
            console.warn('[host] rejected download: invalid token', msg.token);
            return;
          }

          const filename = msg.filename || `visual-export-${new Date().toISOString().replace(/[:.]/g, '-')}.csv`;
          try {
            const blob = new Blob([msg.csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
            try { event.source.postMessage({ source: 'host', action: 'download-complete', success: true }, '*'); } catch (e) { }
          } catch (err) {
            console.error('[host] error saving csv', err);
            try { event.source.postMessage({ source: 'host', action: 'download-complete', success: false, error: String(err) }, '*'); } catch (e) { }
          }
        }
        if (msg.action == REQUEST_ACTION_SHOWONMAP) {

          if (msg?.source !== MESSAGE_SOURCE_SHOWONMAP) {
            console.warn('[host] rejected showonmap: invalid source', msg?.source);
            return;
          }
          // token check
          if (!msg.token || msg.token !== window.SHOWONMAP_TOKEN) {
            console.warn('[host] rejected showonmap: invalid token', msg.token);
            return;
          }
          // const mapValue = {
          //   "property_click": true,
          //   "is_layout": true,
          //   "lat": 29.37537196,
          //   "lon": 47.99140321,
          //   "property_name": "25Th February Tower",
          //   "property_uid": "LKWTAF3992"
          // }

          const mapValue = (msg.value && typeof msg.value[0] === 'string') ? JSON.parse(msg.value[0]) : null;
          if (mapValue && mapValue?.on_click == BiShowOnMapType.PROPERTY) {
            if (mapValue.property_click) {
              this.panToMap(mapValue, 'property_name', 'showOnMap', true, (mapValue?.is_layout == 1 ? true : false));
            } else {
              this.panToMap(mapValue, 'property_name', 'showOnMap');
            }
          }else if(mapValue && mapValue?.on_click == BiShowOnMapType.NEIGHBOURHOOD){
            this.panToMap(mapValue, 'neigh_name', 'showOnMap');

          }else if(mapValue && mapValue?.on_click == BiShowOnMapType.PROJECT){
            if (mapValue.project_click) {
              this.panToMap(mapValue, 'project_name', 'showOnMap', true);
            }else{
              this.panToMap(mapValue, 'project_name', 'showOnMap');
            }

          }
          // console.log(mapValue);
        }

      } catch (err) {
        console.error('[host] message handler top-level error', err);
      }
    }, false);

  }

  // updateSubMenu() {
  //   const langKey = this.sharedService.getCurrentLangID();

  //   this.overViewMenu = this.activeTabName?.pb_container
  //     .slice()
  //     .sort((a: any, b: any) => Number(a.sort_order) - Number(b.sort_order))
  //     .map((e: any) => ({
  //       label: e.label?.[langKey] ?? e.label?.['1'] ?? e.label,
  //       name: e.sort_order,
  //       count: null
  //     }));

  //   if (this.overViewMenu?.length) {
  //     this.currentScroll = this.overViewMenu[0].name;

  //     setTimeout(() => {
  //       this.scrollPoint(this.currentScroll);
  //     }, 300);
  //   }

  // }

  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  scrollPoint(menu: number) {
    setTimeout(() => {
      this.sharedService.scrollMenu(String(menu));
    }, 200);
  }

  bootstrapVisuals(): void {
    // for (const page of this.report_data?.pb_container) {

        // const el = document.getElementById(`${page.page_name}+'_page_'+${page.pb_page_id}`);
        const el = document.getElementById(`pageId`);
        if (!el) return;
          this.powerbiService.bootstrap(el, { type: 'visual' });
    // }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['params'] && changes['params'].currentValue && !changes['params'].firstChange) {
      if (this.params?.polygon) {
        this.getCatchmentCount(this.params?.polygon);
      } else {
        this.getVisualFilter();
      }
    }
  }
  ngAfterViewInit() {
    //Check left & right arrow visible or not function
    this.setupResizeObserver();
  }
  setLang(): void {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
      setTimeout(() => {
        this.checkArrows();
      }, 1000)
    })
  }

  updateLayoutSetting() {
    const element = this.activeTabName;
    let existEmbUrl = this.embedDataURL.find((e:any) => e.pbgid == element.pb_group_id && e.pbrid == element.pb_report_id && e.page_name == element.page_name)
    if(existEmbUrl){
      this.SelectTab(element);
      // this.embedVisualsPhased(existEmbUrl.embedData, element);
    }
  }

   async SelectTab(page: any)  {
    if(this.activeTabName?.pb_page_id == page.pb_page_id){
      return;
    }
    this.activeTabName = page;
    // this.updateSubMenu();
    try {
    const pages = await this.reportPage.getPages();
    const selectedPage = pages.find((p: any) => p.name === page.pb_page_id);
    await selectedPage.setActive();
    this.getVisualFilter();
    } catch (error) {

    }
    // const element = this.activeTabName;
    // let existEmbUrl = this.embedDataURL.find((e:any) => e.pbgid == element.pb_group_id && e.pbrid == element.pb_report_id && e.page_name == element.page_name)
    // if(existEmbUrl && (this.currentReportView != existEmbUrl?.viewId)){
    //   this.embedDataURL = this.embedDataURL.map((item:any)=>{
    //     if(item.pbgid == element.pb_group_id && item.pbrid == element.pb_report_id && item.page_name == element.page_name){
    //       item.viewId = this.currentReportView;
    //     }
    //     return item;
    //   })
    //    this.embedVisualsPhased(existEmbUrl.embedData, element);
    // }else{
    //    this.loadVisualReport(page);
    // }
  }
  /**
   * Resize div call this function
  */
  private setupResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => this.checkArrows());
    this.resizeObserver.observe(this.reportTab.nativeElement);
  }

  checkArrows() {
    if (!this.reportTab) return;

    const element = this.reportTab.nativeElement;
    const scrollLeft = element.scrollLeft;
    const clientWidth = element.clientWidth;
    const scrollWidth = element.scrollWidth;

    const tolerance = 5;
    const isRTL = this.currentLang !== 'en';

    if (isRTL) {
      // For Arabic or any RTL language
      const absLeft = Math.abs(scrollLeft);
      const remainingScroll = scrollWidth - clientWidth - absLeft;

      // Right arrow (scroll more left visually)
      this.showRightArrow = absLeft > tolerance;

      // Left arrow (scroll more right visually)
      this.showLeftArrow = remainingScroll > tolerance;
    } else {
      // For English or any LTR language
      this.showLeftArrow = scrollLeft > tolerance;
      this.showRightArrow = Math.ceil(scrollLeft + clientWidth) < scrollWidth - tolerance;
    }
  }

  /**
   * Scroll To LeftSide
  */
  scrollLeft() {
    const clientWidth = this.reportTab.nativeElement.clientWidth;
    this.reportTab.nativeElement.scrollBy({ left: -(clientWidth / 3), behavior: 'smooth' });
    setTimeout(() => this.checkArrows(), 300);
  }
  /**
   * Scroll To RightSide
  */
  scrollRight() {
    const clientWidth = this.reportTab.nativeElement.clientWidth;
    this.reportTab.nativeElement.scrollBy({ left: clientWidth / 3, behavior: 'smooth' });
    setTimeout(() => this.checkArrows(), 300);
  }

  trackByMenuName(index: number, item: any) {
    return item.name;
  }

  //Get Catchment for draw catchment
  getCatchmentCount(polygon: any) {
    let queryParams = { ...this.params };
    this.reportService.getCatchmentproperties(polygon, queryParams).subscribe((res: any) => {
      if (res.status === 200) {
        this.catchmentCount = res.data;
        this.getVisualFilter();
      }
    });
  }

  loadVisualReport(element: any): void {
    let existEmbUrl = this.embedDataURL.find((e:any) => e.pbgid == element.pb_group_id && e.pbrid == element.pb_report_id && e.page_name == element.page_name && e.viewId == this.currentReportView)
    if(existEmbUrl){
    }else{
      this.pageLoader = true;
      this.reportService
        .powerBiFecthReport(
          element.pb_group_id,
          element.pb_report_id
        )
        .subscribe({
          next: res => {
            this.pageLoader = false
            let embedData = res.data;
            this.embedDataURL.push({
              pbgid : element.pb_group_id,
              pbrid : element.pb_report_id,
              page_name: element.page_name,
              embedData: embedData,
              viewId: this.currentReportView,
              pb_page_id: element.pb_page_id
            })
            this.embedVisualsPhased(embedData, element);
          },
          error: () => (this.pageLoader = false)
        });
    }

  }

  async embedVisualsPhased(embedData:any, page:any): Promise<void> {
    // this.visualsGrFilter = [];
    // for (const page of this.report_data?.pb_container) {
          this.pageLoader=true;
          // const el = document.getElementById(`${page.page_name}_page_${page.pb_page_id}`);
          const el = document.getElementById(`pageId`);

          if (!el) return;

          const config: pbi.IReportEmbedConfiguration = {
            type: 'report',
            id: page.pb_report_id,
            embedUrl: embedData.embedUrl,
            tokenType: models.TokenType.Embed,
            accessToken: embedData.token,
            pageName: page.pb_page_id,
            settings: {
              filterPaneEnabled:false,
              background: models.BackgroundType.Transparent,
              layoutType: models.LayoutType.Custom,
              customLayout: { displayOption: models.DisplayOption.FitToWidth },
              panes: {
                pageNavigation: { visible: false },
                filters: { visible: false, expanded: false },
                bookmarks: { visible: false },
                visualizations: { visible: true, expanded: false },
                fields: { visible: true, expanded: false },
                selection: { visible: false },
                syncSlicers: { visible: false },
              }
            },
          };

           let existing = this.getEmbeddedInstance(el);

          if (existing) {
              this.powerbiService.reset(el);
          }

          this.reportPage = this.powerbiService.embed(el, config);

          this.visualsGrFilter.push(this.reportPage);
          await new Promise<void>(resolve => {
            this.reportPage.on('loaded', () => {
              this.pageLoader=false;
              this.getVisualFilter();
              // visual.on('dataSelected', (event) => {
              //   let data = event.detail;
              // })
              resolve()
            });
            this.reportPage.on("rendered", () => {
             this.pageLoader=false;
            });
            this.reportPage.on('error', () => { this.pageLoader=false; resolve()});
        })
    // }
  }

getEmbeddedInstance(el: HTMLElement) {
  try {
    return this.powerbiService.get(el);
  } catch {
    return null;
  }
}


  async getVisualFilter() {
    //Basics filter
    let basicFilter: any = await this.reportService.createFilterJson(this.params, this.catchmentCount);
    console.log('BI Filters <<< ', basicFilter);
    // this.visualsGrFilter.forEach((visual: any) => {
      this.reportPage.setFilters(basicFilter);
    // });
  }


  async panToMap(
    value: any,
    columnName: any,
    type: string = '',
    isPropertyName: boolean = false,
    isFloorLayout: boolean = false,
    unit_layout: boolean = false) {

      this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
      let layer_data = this.reportService.getCurrentReport();

      if (value?.lat && value?.lon && type != 'layout') {

        // click on neigh_name
        if (value.neigh_name && columnName == 'neigh_name') {
          let layerdat = layer_data?.map_layer?.filter((r: any) => r.layer_name == "neighbourhoods")[0];
          let zoom = 13
          if (layerdat) {
            layerdat.display = true;
            zoom = (Math.ceil((layerdat.maxZoom - layerdat.minZoom) / 2) + layerdat.minZoom);
          }
          this.mapService.overlay_mapLayer.next([layerdat]);
          this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: zoom, uid: value?.property_uid, layer_name: 'neighbourhood' });
        }

         // click on project_name
        if (value.project_name && columnName == 'project_name') {

          let layerdat = layer_data?.map_layer?.find((r: any) => r.layer_name == layerConstant.miprojects);
          let zoom = 16;
          if (layerdat) {
            layerdat.display = true;
            zoom = (Math.ceil((layerdat.maxZoom - layerdat.minZoom) / 2) + layerdat.minZoom);
          }
          this.mapService.overlay_mapLayer.next([layerdat]);
          value['proj_name'] = JSON.stringify(value?.project_label);

          this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: zoom, uid: value?.property_uid, layer_name: 'project', data: value, isNameClicked: isPropertyName, isFloorLayout, columnName: columnName });
        }

        // click on Property
        if (value?.property_uid && columnName == 'property_name') {
          try {
            let uid = value?.property_uid;
            const propertyData: any = await this.mapService.getParcelInfo(uid);
            if (propertyData.status == 200 && propertyData?.data?.length) {
              let properties = { ...propertyData.data[0], is_layout: value?.is_layout };
              this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: 18, uid: uid, layer_name: 'property', data: properties, isNameClicked: isPropertyName, isFloorLayout, columnName: columnName });
              if(isFloorLayout) this.showLayout(properties);
            } else {
              this.alertService.warn(this.translate.instant("reports.no_record_found"));
            }
          } catch (error) {
            this.alertService.warn("Something went Wrong!, Try Again");
          }
        }
      }
      if (type == 'showOnMap' && value?.tenants_lat_lon) {
        if (value?.shop_name) {
          this.reportService.retailInventoryTenantDetails(value.shop_name).subscribe((item: any) => {
            if (item.status == 200) {
              this.mapService.mapCoordinates.next({ data: item.data, multiLatLon: true, tenant_name: value?.tenant_name, zoom: 18 });
            } else { this.alertService.warn(this.translate.instant("reports.no_record_found")); };
          })
        } else {
          this.alertService.warn(this.translate.instant("reports.no_record_found"));
        }
        // this.mapService.mapCoordinates.next({coordinates:value?.tenants_lat_lon, multiLatLon: true, tenant_name: value?.tenant_name});
      }
      if (type == 'layout' && !unit_layout) {
        this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
        this.showLayout(value, true)
      }
      if (type == 'layout' && unit_layout) {
        this.showTenant(value);
      }
    }

  showLayout(value: any, is_unit_layout?: boolean) {
    if (is_unit_layout) value['is_unit_layout'] = true;
    this.mapService.propertyinfotoggle.next(true);
    this.mapService.selected_propertydetails.next(value);
    this.reportService.showTenantMap$.next(value);
  }

  showTenant(value: any) {
    this.reportService.showUnitTenantMap$.next(value);
  }
  ngOnDestroy() {
    this.activeTabName = null;
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    this.languageSub$.unsubscribe();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    this.visualsGrFilter.forEach((v: any) => v.off());
  }

}
